


























































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { ICartCourse, ILoginCredentials, IParentProfile, IStudentListItem, IPaypalItem, ICalendarSession, IPriceTier, ICalendar, IStudentListCartItem, IValidations } from '@/interfaces';
import { CartGetters, UserGetters } from '@/Getters';
import { StudentListCartItemValidator, CartCourseValidator } from '@/validators';
import { AjaxHelper } from '@/AjaxHelper';

import List from '@/components/List.vue';
import ListItem from '@/components/ListItem.vue';
import Btn from '@/components/Btn.vue';
import Field from '@/components/Field.vue';
import TextField from '@/components/TextField.vue';
import VSelect from 'vue-select';
import StudentForm from '@/components/forms/StudentForm.vue';

@Component({
  name: 'cart-details-student-step-page',
  components: { List, ListItem, Btn, Field, TextField, VSelect, StudentForm }
})
export default class CartDetailsStudentStepComponent extends Vue {
  @Prop() public sessions!: Record<string, ICalendarSession[]>;
  @Prop() public priceTiers!: Record<string, IPriceTier[]>;

  public get cartItems(): ICartCourse[] { return this.$store.getters[CartGetters.getCourses]; }
  public get isAuthenticated(): boolean { return this.$store.getters[UserGetters.isAuthenticated]; }
  public get students(): IStudentListItem[] { return this.profile?.students ?? []; }

  public get validationErrors(): (IValidations<IStudentListCartItem> | null)[][] {
    return this.cartItems.map(x => x.studentSessions.map(y => {
      if (!this.showErrors) return null;

      const validation = this.studentValidator.isValid(y);
      return validation === true ? null : validation;
    }));
  }

  public get isValid(): boolean {
    return this.validationErrors.findIndex(x => x.findIndex(y => y !== null) !== -1) === -1;
  }

  public profile: IParentProfile<IStudentListItem> | null = null;
  public editableStudent: IStudentListItem | null = null;
  public addingStudent = false;
  public showErrors = false;

  public studentValidator = new StudentListCartItemValidator();

  public addNewStudent() {
    this.editableStudent = { firstName: '', lastName: '', minecraftAccountId: 'test', minecraftAccountUserName: '', moodleUserName: '', birthDate: null };
  }

  public async saveStudent(newStudent: IStudentListItem) {
    if (this.profile !== null) {
      if (newStudent.studentId === undefined) {
        const student = await AjaxHelper.post<IStudentListItem, IStudentListItem>('/parentstudentmanagement', newStudent);
        this.profile.students.push(student);
      } else {
        const student = await AjaxHelper.put<IStudentListItem, IStudentListItem>('/parentstudentmanagement', newStudent);
        const index = this.profile.students.findIndex(x => x.studentId === student.studentId);
        if (index > -1) {
          this.profile.students.splice(index, 1, student);
        }
      }

      setTimeout(() => this.editableStudent = null);
    }
  }

  public cancelStudentEdit() {
    this.editableStudent = null;
  }

  public onDragStart(e: DragEvent, student: IStudentListItem) {
    const target = e.target as HTMLElement;
    if (target) {
      target.style.opacity = '0.4';
    }

    if (e.dataTransfer !== null) {
      e.dataTransfer.effectAllowed  = 'move';
      e.dataTransfer.setData('text/plain', JSON.stringify(student));
    }
  }

  public onDragEnd(e: DragEvent) {
    const target = e.target as HTMLElement;
    if (target) {
      target.style.opacity = '1';
    }

    if (Array.isArray(this.$refs.droptargets)) {
      for (let i = 0; i < this.$refs.droptargets.length; ++i) {
        const target = this.getEle(this.$refs.droptargets[i]);
        target.classList.remove('border-dashed');
      }
    }
  }

  public onDragEnter(e: DragEvent) {
    const target = this.getDropTarget(e);
    if (target !== null) {
      target.classList.add('border-dashed');
    }
  }

  public onDragLeave(e: DragEvent) {
    const target = this.getDropTarget(e);
    if (target !== null) {
      target.classList.remove('border-dashed');
    }
  }

  public onDragOver(e: DragEvent) {
    e.preventDefault();

    const target = this.getDropTarget(e);
    if (target !== null && !target.classList.contains('border-dashed')) {
      target.classList.add('border-dashed');
    }
    return false;
  }

  public onDrop(e: DragEvent, course: ICartCourse) {
    e.preventDefault();
    e.stopPropagation();

    if (e.dataTransfer !== null) {
      const student = JSON.parse(e.dataTransfer.getData('text/plain')) as IStudentListItem;
      if (!this.$store.dispatch('addStudentToCourseItem', { course, student })) {
        this.$alert.warning('Validation Error', 'Student has already been added to this course');
      }
    }
  }

  public onStudentSessionChange(course: ICartCourse, student: IStudentListCartItem, session: ICalendarSession | null) {
    if (session === null) {
      student.priceTierId = null;
    }

    if (!this.$store.dispatch('updateStudentToCourseItem', { course, student })) {
      this.$alert.warning('Validation Error', 'Cannot update student from this course');
    }
  }

  public onStudentPriceTierChange(course: ICartCourse, student: IStudentListCartItem, priceTier: IPriceTier | null) {
    if (!this.$store.dispatch('updateStudentToCourseItem', { course, student })) {
      this.$alert.warning('Validation Error', 'Cannot update student from this course');
    }
  }

  public removeStudent(course: ICartCourse, student: IStudentListItem) {
    if (!this.$store.dispatch('removeStudentFromCourseItem', { course, student })) {
      this.$alert.warning('Validation Error', 'Cannot remove student from this course');
    }
  }

  public onStudentSelect(student: IStudentListItem, course: ICartCourse) {
    if (!this.$store.dispatch('addStudentToCourseItem', { course, student })) {
      this.$alert.warning('Validation Error', 'Student has already been added to this course');
    }
  }

  public getStudentValidation(validations: IValidations<IStudentListCartItem> | null, key: keyof IStudentListCartItem) {
    return validations !== null && validations[key] !== undefined ? validations[key] : [];
  }

  public nextStep() {
    const validator = new CartCourseValidator();
    const checks = this.cartItems.map(x => validator.isValid(x));
    if (checks.findIndex(x => x !== true) === -1) {
      this.$emit('next');
    } else {
      this.$alert.warning('Validation errors occured please fix before continuing');
      this.showErrors = true;
    }
  }

  @Watch('isAuthenticated', { immediate: true })
  public async onIsAuthenticatedChanged(newIsAuthenticated: boolean) {
    if (newIsAuthenticated) {
      this.profile = await AjaxHelper.get<IParentProfile<IStudentListItem>>('parentprofile');
    } else {
      this.profile = null;
    }
  }

  private getEle(item: Vue | Element) {
    if (item instanceof Vue) return (item as Vue).$el as HTMLElement;
    return item as HTMLElement;
  }

  private getDropTarget(e: DragEvent) {
    const targets = this.$refs.droptargets;
    if (Array.isArray(targets)) {
      const items = e.composedPath();
      for (let i = 0; i < items.length; ++i) {
        const item = (targets as (Vue | Element)[]).find(x => this.getEle(x) === items[i]);
        if (item !== undefined) return this.getEle(item) as HTMLElement;
      }
    }
    return null;
  }
}
